@if (position() === 'start') {
    <ng-container *ngTemplateOutlet="iconTpl" />
}

@if (count()) {
    <span class="count">{{ count() }}</span>
}

@if (projectedLabel()) {
    <ng-content select="[qpxPillLabel]" />
} @else {
    <span class="qpx-pill__label">{{ label() }}</span>
}

@if (position() === 'end') {
    <ng-container *ngTemplateOutlet="iconTpl" />
}

<ng-template #iconTpl>
    <span
        [class]="iconClassName()"
        [class.start]="position() === 'start'"
        [class.end]="position() === 'end'"
        [class.none]="!hasContent() && !hasIcon()"
    >
        <ng-content />

        @if (hasIcon()) {
            <ng-icon qpx [size]="iconSize()" [name]="iconName()" />
        }
    </span>
</ng-template>
